var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "uphold" }, [
      _c("div", { staticClass: "center" }, [
        _c("div", { staticClass: "logo" }, [
          _c("img", { attrs: { src: require("static/logo.png"), alt: "" } })
        ]),
        _c("dl", [
          _c("dt", [
            _c("img", { attrs: { src: require("static/ng.png"), alt: "" } })
          ]),
          _c("dd", [
            _c("h1", [_vm._v("网站升级维护公告")]),
            _c("p", [
              _vm._v("系统升级暂停服务 如本次升级给您带来的不便 请谅解")
            ]),
            _c("img", {
              attrs: {
                src: require("static/3M9R5_ML2LXJP90WWU9TO.jpg"),
                alt: ""
              }
            })
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53ca7293", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53ca7293","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/uphold.vue
// module id = 6079
// module chunks = 22